import { EntityType, PackType, RoutePaths } from 'types/enums';
import { useToLocalizedPath } from 'hooks/useToLocalizedPath/useToLocalizedPath';
import { useCallback } from 'react';

const packTypeToEntityType = {
    Pack: EntityType.Pack,
    Repack: EntityType.RePack,
};

const useGetLocalizedEntityDetailsLink = () => {
    const toLocalizedPath = useToLocalizedPath();

    // Note: Should use this helper for all details link logic - https://mixgenius.atlassian.net/browse/SP-8718
    const getLocalizedEntityDetailsLink = useCallback(
        (type?: EntityType | PackType, slug?: string): string | undefined => {
            let to;
            let entityType;

            if (!type || !slug) {
                return undefined;
            }

            if (type === PackType.Pack || type === PackType.RePack) {
                entityType = packTypeToEntityType[type as PackType];
            } else {
                entityType = type;
            }

            switch (entityType) {
                case EntityType.Pack:
                    to = toLocalizedPath(`/${RoutePaths.Packs}/${slug}`);
                    break;

                case EntityType.RePack:
                    to = toLocalizedPath(`/${RoutePaths.RePacks}/${slug}`);
                    break;

                case EntityType.Label:
                    to = toLocalizedPath(`/${RoutePaths.Labels}/${slug}`);
                    break;

                case EntityType.Artist:
                    to = toLocalizedPath(`/${RoutePaths.Artists}/${slug}`);
                    break;
            }

            return to;
        },
        [toLocalizedPath],
    );

    return getLocalizedEntityDetailsLink;
};

export default useGetLocalizedEntityDetailsLink;
